// SIMULASI (Preview saja) — Cetak Mockup + Resi berpasangan. Tanpa Shopee API, tanpa ubah status.
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const isPreviewHost = (host = window.location.hostname) => /\.preview\.emergentagent\.com$/.test(host);

export function useAwbSimEnabled() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!isPreviewHost()) return;
    axios.get(`${API}/shopee/awb-sim/status`, { withCredentials: true })
      .then(r => setOn(!!r.data?.enabled)).catch(() => setOn(false));
  }, []);
  return on;
}

const toBlobUrl = (b64) => {
  const bin = atob(b64); const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return URL.createObjectURL(new Blob([arr], { type: "application/pdf" }));
};

export function AwbSimButton({ jobs, onOpen }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/shopee/awb-sim/paired-pdf`, { job_ids: jobs.map(j => j.id) }, { withCredentials: true });
      const url = toBlobUrl(r.data.pdf_base64);
      window.open(url, "_blank", "noopener");
      onOpen({ ...r.data, url });
    } catch (e) { toast.error(e?.response?.data?.detail || e.message || "Gagal membuat PDF simulasi."); }
    finally { setBusy(false); }
  };
  return <button type="button" className="soft-btn" disabled={busy || jobs.length === 0} onClick={run}
    style={{ borderStyle: "dashed" }} data-testid="wh-shopee-awb-sim-btn">
    {busy ? "Menyiapkan SIMULASI…" : "Cetak Mockup + Resi · A5 Portrait (SIMULASI)"}
  </button>;
}

export function AwbSimResult({ res, onClose }) {
  const close = () => { URL.revokeObjectURL(res.url); onClose(); };
  return createPortal(<div className="modal-backdrop" style={{ zIndex: 1100 }} onClick={close}>
    <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }} data-testid="wh-shopee-awb-sim-result">
      <h3 style={{ marginTop: 0 }}>SIMULASI — Mockup + Resi (A5 Portrait)</h3>
      <div className="warn-box small" data-testid="wh-shopee-awb-sim-warning">SIMULASI — BUKAN RESI PENGIRIMAN. Resi berisi data contoh, tidak ada panggilan Shopee, status pesanan tidak berubah.</div>
      <p style={{ fontWeight: 600 }} data-testid="wh-shopee-awb-sim-summary">{res.with_awb.length} dengan resi simulasi · {res.no_awb.length} TANPA RESI · {res.pages.length} halaman</p>
      {res.no_awb.length > 0 && <div className="muted small" style={{ maxHeight: 120, overflow: "auto" }} data-testid="wh-shopee-awb-sim-noawb">
        {res.no_awb.map(x => <div key={x.order_sn}>{x.order_sn} — {x.reason}</div>)}</div>}
      {res.skipped.length > 0 && <div className="warn-box small" data-testid="wh-shopee-awb-sim-skipped">Tidak ikut: {res.skipped.map(x => `${x.order_sn} (${x.reason})`).join(", ")}</div>}
      <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
        <a className="primary" href={res.url} target="_blank" rel="noopener noreferrer" data-testid="wh-shopee-awb-sim-open">Buka PDF SIMULASI</a>
        <a className="soft-btn" href={res.url} download={`SIMULASI-mockup-resi-${Date.now()}.pdf`} data-testid="wh-shopee-awb-sim-download">Unduh PDF SIMULASI</a>
        <button type="button" className="soft-btn" onClick={close} data-testid="wh-shopee-awb-sim-close">Tutup</button>
      </div>
    </div>
  </div>, document.body);
}
